var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-ability-preview" },
    [
      _c(
        "single-column-container",
        { attrs: { align: "center", "max-width": "1280px" } },
        [
          _c(
            "fix-header",
            {
              attrs: { slot: "header", showBack: _vm.showBack },
              on: { "back-click": _vm.backPage },
              slot: "header",
            },
            [
              _c(
                "div",
                {
                  staticClass: "title",
                  attrs: { slot: "center" },
                  slot: "center",
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.previewBasic.name) + "\n      "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "text-right",
                  attrs: { slot: "right" },
                  slot: "right",
                },
                [
                  _c("yxt-button", { on: { click: _vm.cancelPreview } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("pc_gwnl_jq_btn_cancelPreview").d("关闭预览")
                        ) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          Object.keys(_vm.previewBasic).length > 0
            ? _c(
                "div",
                [
                  _c(
                    "single-column-item",
                    [
                      _c("preview-basic", {
                        ref: "previewBasic",
                        attrs: { "preview-basic": _vm.previewBasic },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "single-column-item",
                    [
                      _c("preview-skills", {
                        ref: "previewSkills",
                        staticClass: "mt32",
                        attrs: {
                          list: _vm.skillCatalogModels,
                          "enable-skill-level": _vm.enableSkillLevel,
                          "enable-weight-switch": _vm.enableWeightSwitch,
                          "enable-excellent-level": _vm.enableExcellentLevel,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }